import { render, staticRenderFns } from "./ModalVerificationCode.vue?vue&type=template&id=1d9f8a5a&scoped=true"
import script from "./ModalVerificationCode.vue?vue&type=script&lang=js"
export * from "./ModalVerificationCode.vue?vue&type=script&lang=js"
import style0 from "./ModalVerificationCode.vue?vue&type=style&index=0&id=1d9f8a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9f8a5a",
  null
  
)

export default component.exports